import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    flexDirection: "column",
  },
  logo: { width: "20%" },
  progress: { width: "20%", marginTop: "2vh" },
  colorProgress: { backgroundColor: theme.palette.primary.main },
}));
